/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import ModalBusquedaAuxiliar from "./components/ModalBusquedaAuxiliar";
import { useNavigate, useParams } from 'react-router-dom';
import { formatMoney, formatDate } from "../utils/utils";

function IngresoReemplazos2() {
    const { id_solicitud } = useParams();
    const navigate = useNavigate();

    const [solicitud, setSolicitud] = useState({});
    const [slots, setSlots] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);

    // Auxiliar target ID to lock other rows
    const [targetAuxiliarID, setTargetAuxiliarID] = useState(null);

    const [isAuxiliarModalOpen, setIsAuxiliarModalOpen] = useState(false);

    const [datosCondiciones, setDatosCondiciones] = useState({
        valorTurno: 0,
        valorColacion: 0,
        valorMovilizacion: 0,
        valorOtro: 0,
        fechaInicio: '',
        fechaFin: '',
        turnoID: 0
    });

    useEffect(() => {
        async function fetchData() {
            gdAlertify.showLoader();
            try {
                const response = await axiosInstance.get("/reemplazos/solicitud/ver/" + id_solicitud);

                let solicitudInfo = response.data.data;
                setSolicitud(solicitudInfo);

                // Set target aux ID for filtering (handle string/int case)
                if (solicitudInfo.auxiliarID) {
                    setTargetAuxiliarID(parseInt(solicitudInfo.auxiliarID));
                }

                setDatosCondiciones({
                    valorTurno: solicitudInfo.valorTurno,
                    valorColacion: solicitudInfo.valorColacion,
                    valorMovilizacion: solicitudInfo.valorMovilizacion,
                    valorOtro: solicitudInfo.valorOtro,
                    fechaInicio: solicitudInfo.fechaInicio,
                    fechaFin: solicitudInfo.fechaFin,
                    turnoID: solicitudInfo.turnoID
                });

                const realShifts = solicitudInfo.turnos || [];

                if (solicitudInfo.fechaInicio && solicitudInfo.fechaFin) {
                    const newSlots = generateDailySlots(
                        solicitudInfo.fechaInicio,
                        solicitudInfo.fechaFin,
                        solicitudInfo.auxiliar,
                        solicitudInfo.turnoID,
                        realShifts,
                        solicitudInfo // Pass full solicitud for fallbacks
                    );
                    setSlots(newSlots);
                }

                gdAlertify.hideLoader();
            } catch (error) {
                gdAlertify.hideLoader();
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, [id_solicitud]);

    const findRealShift = (dateStr, shiftType, fetchedShifts) => {
        return fetchedShifts.find(s => {
            if (s.fecha !== dateStr) return false;
            let sType = 0;
            if (s.tipo === 'day') sType = 1;
            else if (s.tipo === 'night') sType = 2;
            else if (s.tipoTurno) sType = parseInt(s.tipoTurno);
            return sType === shiftType;
        });
    };

    const generateDailySlots = (startStr, endStr, defaultOldAux, turnoID, fetchedShifts, solicitudInfo) => {
        let generated = [];
        // Fix: Parse YYYY-MM-DD manually to prevent UTC->Local shifting causing 'Day-1'
        const [sy, sm, sd] = startStr.split('-').map(Number);
        const [ey, em, ed] = endStr.split('-').map(Number);

        const start = new Date(sy, sm - 1, sd, 12, 0, 0); // Local noon
        const end = new Date(ey, em - 1, ed, 12, 0, 0);

        let current = new Date(start);
        // Always generate Day and Night slots regardless of TurnoID
        const typesToGenerate = [
            { id: 1, label: 'Día' },
            { id: 2, label: 'Noche' }
        ];

        while (current <= end) {
            const dateStr = current.toISOString().split('T')[0];
            typesToGenerate.forEach(type => {
                const realShift = findRealShift(dateStr, type.id, fetchedShifts);

                let oldAuxObj = null; // Por defecto null (sin auxiliar)
                
                if (realShift) {
                    // Prioridad 1: Si hay reemplazo activo
                    if (realShift.reemplazoNombre) {
                        oldAuxObj = {
                            id: realShift.reemplazoID,
                            nombre: realShift.reemplazoNombre,
                            apellidoPaterno: '',
                            apellidoMaterno: ''
                        };
                    } 
                    // Prioridad 2: Si hay auxiliar asignado (y no es null/0)
                    else if (realShift.auxiliarID && parseInt(realShift.auxiliarID) > 0 && realShift.auxiliarNombre) {
                        oldAuxObj = {
                            id: parseInt(realShift.auxiliarID),
                            nombre: realShift.auxiliarNombre,
                            apellidoPaterno: '',
                            apellidoMaterno: ''
                        };
                    }
                    // Si auxiliarID es null o 0, oldAuxObj queda null (no hay nadie asignado)
                }

                // Format name clean
                let displayName = '-';
                if (oldAuxObj && oldAuxObj.nombre) {
                    if (oldAuxObj.apellidoPaterno) {
                        displayName = `${oldAuxObj.nombre} ${oldAuxObj.apellidoPaterno}`;
                    } else {
                        displayName = oldAuxObj.nombre;
                    }
                }

                // Determine Values
                // Priority: RealShift.valorRt > Solicitud.valor
                let vTurno = solicitudInfo?.valorTurno || 0;
                let vColacion = solicitudInfo?.valorColacion || 0;
                let vLocomocion = solicitudInfo?.valorMovilizacion || 0;

                if (realShift) {
                    // Check if value properties exist (might be undefined or 0)
                    if (realShift.valorTurnoRt !== undefined) vTurno = realShift.valorTurnoRt;
                    if (realShift.valorColacionRt !== undefined) vColacion = realShift.valorColacionRt;
                    if (realShift.valorLocomocionRt !== undefined) vLocomocion = realShift.valorLocomocionRt;
                }

                generated.push({
                    date: new Date(current),
                    dateStr: dateStr,
                    shiftLabel: type.label,
                    shiftID: type.id,
                    oldAuxiliar: oldAuxObj,
                    displayName: displayName,
                    newAuxiliar: null,
                    valorTurno: vTurno,
                    valorColacion: vColacion,
                    valorLocomocion: vLocomocion
                });
            });
            current.setDate(current.getDate() + 1);
        }
        return generated;
    };

    const isSlotEditable = (slot) => {
        // Si no hay auxiliar asignado (oldAuxiliar es null o no tiene ID), no se puede reemplazar
        if (!slot.oldAuxiliar || !slot.oldAuxiliar.id) return false;
        
        // Si hay targetAuxiliarID, solo permitir editar slots de ese auxiliar
        if (!targetAuxiliarID) return true;
        return slot.oldAuxiliar.id === targetAuxiliarID;
    };

    const toggleSlotSelection = (index) => {
        if (!isSlotEditable(slots[index])) return;
        if (selectedSlots.includes(index)) {
            setSelectedSlots(selectedSlots.filter(i => i !== index));
        } else {
            setSelectedSlots([...selectedSlots, index]);
        }
    };

    const toggleAllSelection = () => {
        const editableIndices = slots
            .map((slot, idx) => ({ ...slot, idx }))
            .filter(s => isSlotEditable(s))
            .map(s => s.idx);
        const allEditableSelected = editableIndices.length > 0 && editableIndices.every(idx => selectedSlots.includes(idx));

        if (allEditableSelected) {
            setSelectedSlots([]);
        } else {
            setSelectedSlots(editableIndices);
        }
    };

    const handleSeleccionAuxiliar = (auxiliar) => {
        let blockedCount = 0;
        const updatedSlots = slots.map((slot, index) => {
            if (selectedSlots.includes(index) && isSlotEditable(slot)) {
                // If currently marked as "No Reemplazar", do NOT overwrite. User must clear it first.
                if (slot.newAuxiliar && slot.newAuxiliar.id === -999) {
                    blockedCount++;
                    return slot;
                }
                return { ...slot, newAuxiliar: auxiliar };
            }
            return slot;
        });
        setSlots(updatedSlots);
        setSelectedSlots([]);
        setIsAuxiliarModalOpen(false);

        if (blockedCount > 0) {
            gdAlertify.notify(`Se asignó el auxiliar, pero ${blockedCount} turno(s) "No Reemplazar" no se modificaron.`, 'warning');
        } else {
            gdAlertify.notify('Auxiliar asignado a los días seleccionados', 'success');
        }
    };

    const handleSkipSlot = (index) => {
        const slot = slots[index];
        if (!isSlotEditable(slot)) return;

        const updatedSlots = [...slots];
        // Toggle skip status. If already skipped/assigned, reset? No, button meant to set SKIP.
        // Use a sentinel value for "Skipped"
        updatedSlots[index].newAuxiliar = { id: -999, nombre: 'NO REEMPLAZAR', apellidoPaterno: '' };

        setSlots(updatedSlots);
    };

    const handleClearSlot = (index) => {
        const updatedSlots = [...slots];
        updatedSlots[index].newAuxiliar = null;
        setSlots(updatedSlots);
    };

    const handleMassSkip = () => {
        if (selectedSlots.length === 0) return;

        const updatedSlots = [...slots];
        selectedSlots.forEach(index => {
            if (isSlotEditable(updatedSlots[index])) {
                updatedSlots[index].newAuxiliar = { id: -999, nombre: 'NO REEMPLAZAR', apellidoPaterno: '' };
            }
        });
        setSlots(updatedSlots);
        setSelectedSlots([]);
        gdAlertify.notify(`${selectedSlots.length} turnos marcados como "No Reemplazar"`, 'warning');
    };

    const handleMassClear = () => {
        if (selectedSlots.length === 0) return;

        const updatedSlots = [...slots];
        selectedSlots.forEach(index => {
            if (isSlotEditable(updatedSlots[index])) {
                updatedSlots[index].newAuxiliar = null;
            }
        });
        setSlots(updatedSlots);
        setSelectedSlots([]);
        gdAlertify.notify(`Se limpiaron ${selectedSlots.length} turnos`, 'success');
    };

    const handleOpenModal = () => {
        if (selectedSlots.length === 0) {
            gdAlertify.notiError('Seleccione al menos un día de la tabla.');
            return;
        }
        setIsAuxiliarModalOpen(true);
    };

    const getFormattedReemplazos = () => {
        return slots
            .filter(slot => slot.newAuxiliar !== null && slot.newAuxiliar.id !== -999) // Exclude SKIP (-999)
            .map(slot => ({
                pacienteID: solicitud.pacienteID,
                auxiliarID: slot.oldAuxiliar ? slot.oldAuxiliar.id : null,
                auxiliarNuevoID: slot.newAuxiliar.id,
                fecha: slot.dateStr,
                periodo: slot.shiftID === 1 ? 'day' : 'night'
            }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Strict Validation: check if all editable slots have a replacement or are skipped
        const editableSlots = slots.filter(s => isSlotEditable(s));
        const unassignedSlots = editableSlots.filter(s => !s.newAuxiliar);

        if (unassignedSlots.length > 0) {
            const totalEditable = editableSlots.length;
            const assigned = editableSlots.filter(s => s.newAuxiliar && s.newAuxiliar.id !== -999).length;
            const skipped = editableSlots.filter(s => s.newAuxiliar && s.newAuxiliar.id === -999).length;
            const pending = unassignedSlots.length;

            gdAlertify.notiError(
                `No se puede guardar. Faltan ${pending} turno(s) por completar.\n\n` +
                `Estado actual:\n` +
                `✓ Asignados: ${assigned}\n` +
                `⊘ No Reemplazar: ${skipped}\n` +
                `✗ Pendientes: ${pending}\n` +
                `━━━━━━━━━━━━━━━━\n` +
                `Total: ${totalEditable}`
            );
            return false;
        }

        const reemplazosPayload = getFormattedReemplazos();
        const skippedCount = editableSlots.filter(s => s.newAuxiliar && s.newAuxiliar.id === -999).length;

        // Validación: Si todos están marcados como "No Reemplazar"
        if (reemplazosPayload.length === 0 && skippedCount > 0) {
            gdAlertify.confirm({
                title: '⚠️ Todos los turnos marcados como "No Reemplazar"',
                message: `Todos los ${skippedCount} turnos fueron marcados como "No Reemplazar".\n\n¿Desea continuar y cerrar la solicitud sin asignar reemplazos?`,
                onConfirm: async () => {
                    gdAlertify.showLoader();
                    try {
                        const response = await axiosInstance.post("/auxiliar/reemplazo/new-crear", {
                            solicitudEnvio: { ...solicitud, reemplazos: [] },
                        });

                        if (!response.data.error) {
                            gdAlertify.notiSuccess(response.data.message);
                            navigate('/solicitudes-reemplazos');
                        } else {
                            gdAlertify.notiError(response.data.message);
                        }
                        gdAlertify.hideLoader();
                    } catch (error) {
                        gdAlertify.hideLoader();
                        console.error(error);
                        gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                    }
                },
                onCancel: () => {
                    gdAlertify.notify('Operación cancelada', 'info');
                }
            });
            return;
        }

        // Confirmación normal con desglose
        // Construir el objeto con reemplazos al inicio
        let solicitudEnvio = {
            reemplazos: reemplazosPayload,
            ...solicitud
        };
        console.log(solicitudEnvio);
        const confirmMessage = skippedCount > 0
            ? `¿Desea confirmar la siguiente operación?\n\n` +
            `✓ Reemplazos a asignar: ${reemplazosPayload.length}\n` +
            `⊘ Turnos "No Reemplazar": ${skippedCount}\n` +
            `━━━━━━━━━━━━━━━━━━━━━━━━\n` +
            `Total de turnos: ${editableSlots.length}`
            : `¿Desea confirmar ${reemplazosPayload.length} asignaciones de reemplazo?`;

        gdAlertify.confirm({
            title: 'Confirmar reemplazo',
            message: confirmMessage,
            onConfirm: async () => {
                gdAlertify.showLoader();
                try {
                    const response = await axiosInstance.post("/auxiliar/reemplazo/new-crear", {
                        solicitudEnvio,
                    });

                    if (!response.data.error) {
                        gdAlertify.notiSuccess(response.data.message);
                        navigate('/solicitudes-reemplazos');
                    } else {
                        gdAlertify.notiError(response.data.message);
                    }
                    gdAlertify.hideLoader();
                } catch (error) {
                    gdAlertify.hideLoader();
                    console.error(error);
                    gdAlertify.notiError("Ocurrió un error al conectar con el servidor.");
                }
            },
            onCancel: () => {
                gdAlertify.notify('Envío cancelado', 'error');
            }
        });
    };

    const editableCount = slots.filter(s => isSlotEditable(s)).length;
    const isAllSelected = editableCount > 0 && slots.every((s, idx) => !isSlotEditable(s) || selectedSlots.includes(idx));


    return (
        <div className="container mt-4">
            <div className="card shadow-sm">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-3">
                        <h2 className="text-primary m-0"><i className="fas fa-calendar-check me-2"></i>Gestión de Reemplazo</h2>
                        {solicitud.paciente && (
                            <div className="text-end text-muted">
                                <div><span className="fw-bold text-dark">{solicitud.paciente.nombres} {solicitud.paciente.apellidoPaterno}</span></div>
                                <div><small>Rango: {formatDate(solicitud.fechaInicio)} / {formatDate(solicitud.fechaFin)}</small></div>
                                {solicitud.auxiliar && (
                                    <div className="badge bg-warning text-dark mt-1">
                                        Reemplazando a: {solicitud.auxiliar.nombre} {solicitud.auxiliar.apellidoPaterno}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Action Bar */}
                    <div className="d-flex gap-2 mb-3 bg-light p-3 rounded align-items-center border">
                        <button
                            className="btn btn-primary"
                            onClick={handleOpenModal}
                            disabled={selectedSlots.length === 0}
                        >
                            <i className="fas fa-user-plus me-2"></i>
                            Asignar Reemplazo ({selectedSlots.length})
                        </button>
                        <button
                            className="btn btn-outline-danger"
                            onClick={handleMassSkip}
                            disabled={selectedSlots.length === 0}
                            title="Marcar seleccionados como 'No Reemplazar'"
                        >
                            <i className="fas fa-ban me-2"></i>
                            No Reemplazar
                        </button>
                        <button
                            className="btn btn-outline-secondary"
                            onClick={handleMassClear}
                            disabled={selectedSlots.length === 0}
                            title="Quitar asignación/estado de seleccionados"
                        >
                            <i className="fas fa-eraser me-2"></i>
                            Limpiar
                        </button>
                        <div className="flex-grow-1 text-end text-secondary">
                            <small>Solo puede reemplazar turnos asignados al auxiliar original de la solicitud.</small>
                        </div>
                    </div>

                    <ModalBusquedaAuxiliar
                        isOpen={isAuxiliarModalOpen}
                        onClose={() => setIsAuxiliarModalOpen(false)}
                        onSelect={handleSeleccionAuxiliar}
                        pacienteAuxiliares={solicitud.paciente?.auxiliares || []}
                        excludeAuxiliarID={targetAuxiliarID}
                    />

                    {/* Comparison Table */}
                    <div className="table-responsive rounded border">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-white position-sticky top-0 shadow-sm" style={{ zIndex: 1 }}>
                                <tr>
                                    <th style={{ width: '50px' }} className="text-center bg-light">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={isAllSelected}
                                            onChange={toggleAllSelection}
                                            disabled={editableCount === 0}
                                        />
                                    </th>
                                    <th className="bg-light">Día</th>
                                    <th className="bg-light">Fecha</th>
                                    <th className="bg-light">Turno</th>
                                    <th className="bg-light text-muted">Ausente (Original)</th>
                                    <th className="bg-light text-success">Reemplazo (Nuevo)</th>
                                    <th className="bg-light text-end">V. Turno</th>
                                    <th className="bg-light text-end">V. Colación</th>
                                    <th className="bg-light text-end pe-3">V. Locomoción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {slots.map((slot, index) => {
                                    const editable = isSlotEditable(slot);
                                    // Blue for Day (1), Red for Night (2)
                                    const textClass = slot.shiftID === 1 ? 'text-primary' : 'text-danger';

                                    return (
                                        <tr
                                            key={`${slot.dateStr}-${slot.shiftID}`}
                                            className={selectedSlots.includes(index) ? 'table-warning' : (editable ? '' : 'table-light text-muted')}
                                            style={!editable ? { opacity: 0.6 } : {}}
                                        >
                                            <td className="text-center">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={selectedSlots.includes(index)}
                                                    onChange={() => toggleSlotSelection(index)}
                                                    disabled={!editable}
                                                />
                                            </td>
                                            <td className={`fw-bold ${textClass} text-capitalize`}>
                                                {slot.date.toLocaleDateString('es-CL', { weekday: 'long' })}
                                            </td>
                                            <td className={textClass}>{formatDate(slot.dateStr)}</td>
                                            <td className={textClass}>
                                                {slot.shiftLabel}
                                            </td>
                                            <td className="">
                                                {slot.oldAuxiliar ? (
                                                    <span className={`d-flex align-items-center gap-2 ${!editable ? 'text-decoration-line-through' : ''}`}>
                                                        <i className={`fas ${editable ? 'fa-user-slash text-secondary' : 'fa-user-lock'}`}></i>
                                                        {slot.displayName}
                                                    </span>
                                                ) : '-'}
                                                {!editable && slot.oldAuxiliar && (
                                                    <div style={{ fontSize: '0.75rem' }} className="text-danger fst-italic">
                                                        No corresponde a solicitud
                                                    </div>
                                                )}
                                            </td>
                                            <td className="" style={{ verticalAlign: 'middle' }}>
                                                {slot.newAuxiliar
                                                    ? <div className="d-flex align-items-center justify-content-between">
                                                        {slot.newAuxiliar.id === -999
                                                            ? (
                                                                <span className="badge bg-secondary bg-opacity-10 text-secondary border border-secondary border-opacity-25 px-3 py-2 rounded-pill">
                                                                    <i className="fas fa-ban me-2"></i>No Reemplazar
                                                                </span>
                                                            )
                                                            : (
                                                                <span className="d-flex align-items-center text-success fw-bold">
                                                                    <i className="fas fa-user-check me-2"></i>
                                                                    {slot.newAuxiliar.nombre} {slot.newAuxiliar.apellidoPaterno}
                                                                </span>
                                                            )
                                                        }

                                                        {editable && (
                                                            <button
                                                                className="btn btn-link text-danger p-0 ms-2"
                                                                onClick={() => handleClearSlot(index)}
                                                                title="Quitar asignación"
                                                                style={{ textDecoration: 'none' }}
                                                            >
                                                                <i className="fas fa-times-circle fa-lg"></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                    : (editable ? (
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small fst-italic ps-2">Sin Asignar</span>
                                                            <button
                                                                className="btn btn-outline-secondary btn-sm border-0 bg-light text-muted"
                                                                onClick={() => handleSkipSlot(index)}
                                                                title="Marcar como 'No Reemplazar'"
                                                                style={{ transition: 'all 0.2s' }}
                                                            >
                                                                <i className="fas fa-ban"></i>
                                                            </button>
                                                        </div>
                                                    ) : <span className="text-danger small fst-italic">No Editable</span>)}
                                            </td>
                                            <td className="text-end font-monospace">{formatMoney(slot.valorTurno)}</td>
                                            <td className="text-end font-monospace">{formatMoney(slot.valorColacion)}</td>
                                            <td className="text-end font-monospace pe-3">{formatMoney(slot.valorLocomocion)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="mt-4 pt-3 border-top">
                        {(() => {
                            const editableSlots = slots.filter(s => isSlotEditable(s));
                            const assignedSlots = editableSlots.filter(s => s.newAuxiliar && s.newAuxiliar.id !== -999);
                            const skippedSlots = editableSlots.filter(s => s.newAuxiliar && s.newAuxiliar.id === -999);
                            const pendingSlots = editableSlots.filter(s => !s.newAuxiliar);
                            const totalEditable = editableSlots.length;
                            const completedSlots = assignedSlots.length + skippedSlots.length;
                            const isComplete = pendingSlots.length === 0;
                            const completionPercentage = totalEditable > 0 ? (completedSlots / totalEditable) * 100 : 0;

                            return (
                                <>
                                    {/* Progress Bar */}
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="fw-bold text-dark">
                                                Progreso de Asignación
                                            </span>
                                            <span className={`badge ${isComplete ? 'bg-success' : 'bg-warning text-dark'}`}>
                                                {completedSlots} / {totalEditable} turnos completados ({completionPercentage.toFixed(0)}%)
                                            </span>
                                        </div>
                                        <div className="progress" style={{ height: '25px' }}>
                                            <div
                                                className="progress-bar bg-success"
                                                role="progressbar"
                                                style={{ width: `${(assignedSlots.length / totalEditable) * 100}%` }}
                                                aria-valuenow={assignedSlots.length}
                                                aria-valuemin="0"
                                                aria-valuemax={totalEditable}
                                            >
                                                {assignedSlots.length > 0 && `${assignedSlots.length} Asignados`}
                                            </div>
                                            <div
                                                className="progress-bar bg-secondary"
                                                role="progressbar"
                                                style={{ width: `${(skippedSlots.length / totalEditable) * 100}%` }}
                                                aria-valuenow={skippedSlots.length}
                                                aria-valuemin="0"
                                                aria-valuemax={totalEditable}
                                            >
                                                {skippedSlots.length > 0 && `${skippedSlots.length} No Reemplazar`}
                                            </div>
                                            <div
                                                className="progress-bar bg-danger"
                                                role="progressbar"
                                                style={{ width: `${(pendingSlots.length / totalEditable) * 100}%` }}
                                                aria-valuenow={pendingSlots.length}
                                                aria-valuemin="0"
                                                aria-valuemax={totalEditable}
                                            >
                                                {pendingSlots.length > 0 && `${pendingSlots.length} Pendientes`}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Status Summary */}
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="d-flex gap-3">
                                            <div className="text-muted small">
                                                <i className="fas fa-check-circle text-success me-1"></i>
                                                <strong>{assignedSlots.length}</strong> Asignados
                                            </div>
                                            <div className="text-muted small">
                                                <i className="fas fa-ban text-secondary me-1"></i>
                                                <strong>{skippedSlots.length}</strong> No Reemplazar
                                            </div>
                                            {pendingSlots.length > 0 && (
                                                <div className="text-danger small">
                                                    <i className="fas fa-exclamation-circle me-1"></i>
                                                    <strong>{pendingSlots.length}</strong> Pendientes
                                                </div>
                                            )}
                                        </div>
                                        <button
                                            className={`btn ${isComplete ? 'btn-success' : 'btn-secondary'} px-4 py-2`}
                                            onClick={handleSubmit}
                                            disabled={!isComplete}
                                            title={!isComplete ? 'Complete todos los turnos para guardar' : 'Guardar reemplazos'}
                                        >
                                            <i className="fas fa-save me-2"></i>
                                            Guardar Reemplazos
                                        </button>
                                    </div>
                                </>
                            );
                        })()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default IngresoReemplazos2;
